// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".media-popup[data-v-045ad068] .popUp,.move-to[data-v-045ad068] .popUp{position:fixed}.share-popup[data-v-045ad068]{position:absolute;background:rgba(0,0,0,.5)}.share-popup[data-v-045ad068] .popUp{position:fixed;overflow:hidden}.share-popup[data-v-045ad068] .bottom-navigation{width:100%!important;right:0;top:unset!important;bottom:0}", ""]);
// Exports
module.exports = exports;
